// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld/base/core';
import './widgetControls/widgetSliderControl';

myw.ILayerControlWidget = myw.View.extend({
    /**
     * Interface for class that represent a LayerControlWidget.
     * @interface
     * @param  {Application}       options.app
     * @param  {Layer}             options.layer
     * @constructs
     * @extends  {View}
     */
    initialize(options) {
        myw.View.prototype.initialize.call(this, options);
    }
});

export default myw.ILayerControlWidget;
